var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-parent"},[_c('transition',{attrs:{"name":"slide-fade","duration":{ enter: 300, leave: 200 }}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }